import React, { useEffect, useState } from "react";
import { PageHeader, Toast } from "@/components/Layout";
import api from "@/lib/api";
import MultiSelect from "@/components/MultiSelect";

export default function StatDidacticConfig() {
  const [cfg, setCfg] = useState(null);
  const [msg, setMsg] = useState({ text: "", type: "info" });

  useEffect(() => { api.get("/stat-didactic/config").then(r => setCfg(r.data)); }, []);

  const save = async () => {
    try {
      await api.put("/stat-didactic/config", {
        didactic_personnel_categories: cfg.didactic_personnel_categories,
        department_level: cfg.department_level || null,
        max_management_norm_reduction_percent: parseInt(cfg.max_management_norm_reduction_percent, 10) || 0,
        scope_unit_ids: cfg.scope_unit_ids || [],
      });
      setMsg({ text: "Salvat", type: "success" }); setTimeout(() => setMsg({ text: "" }), 1500);
    } catch (e) { setMsg({ text: e?.response?.data?.detail || "Eroare", type: "error" }); }
  };
  if (!cfg) return <div>Se încarcă...</div>;

  const toggle = (c) => {
    const cur = cfg.didactic_personnel_categories || [];
    setCfg({ ...cfg, didactic_personnel_categories: cur.includes(c) ? cur.filter(x => x !== c) : [...cur, c] });
  };

  return (
    <>
      <PageHeader title="Setări Stat de Funcții Didactic" subtitle="Aplicabilitate și definirea departamentului"
        actions={<button className="btn btn-primary" onClick={save} data-testid="save-sfd-config">Salvează</button>} />
      <Toast msg={msg.text} type={msg.type} />
      <div className="card" style={{ padding: 24, display: "grid", gap: 22 }}>
        <div>
          <div style={{ fontWeight: 700, marginBottom: 4 }}>Categorii de personal didactic</div>
          <div style={{ fontSize: 12, color: "#64748B", marginBottom: 8 }}>
            Statul didactic se aplică persoanelor din categoriile bifate; vechimea în învățământul superior se
            calculează doar din rapoartele lor de muncă. Dacă nu bifați nimic, se iau în calcul toate categoriile.
          </div>
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
            {cfg.available_personnel_categories.map(c => (
              <label key={c} style={{ fontSize: 13, display: "flex", gap: 6, alignItems: "center" }}>
                <input type="checkbox" checked={(cfg.didactic_personnel_categories || []).includes(c)} onChange={() => toggle(c)} />
                {c}
              </label>
            ))}
          </div>
        </div>
        <div style={{ maxWidth: 560 }}>
          <div style={{ fontWeight: 700, marginBottom: 4 }}>Structurile (nivelul 2) la care se aplică modulul</div>
          <div style={{ fontSize: 12, color: "#64748B", marginBottom: 8 }}>
            Alege facultățile (structurile de nivel 2, primul nivel de sub angajator) pentru care se folosește Stat de Funcții Didactic. Celelalte structuri
            <b> nu se mai afișează în acest modul, nici Adminului</b> (selectoare, state, plata cu ora, programe legate de ele); datele lor nu se șterg, doar se ascund.
            Dacă nu alegi nimic, modulul se aplică tuturor structurilor.
          </div>
          <MultiSelect options={(cfg.level2_units || []).map(u => ({ value: u.id, label: u.path }))} value={cfg.scope_unit_ids || []}
            onChange={v => setCfg({ ...cfg, scope_unit_ids: v })} allLabel="Toate structurile" minWidth={320} testId="sfd-scope-units" />
        </div>
        <div style={{ maxWidth: 420 }}>
          <label className="label">Nivelul din structura organizatorică care reprezintă „departamentul”</label>
          <select className="select" value={cfg.department_level || ""} data-testid="sfd-department-level"
            onChange={e => setCfg({ ...cfg, department_level: e.target.value ? parseInt(e.target.value, 10) : null })}>
            <option value="">— nesetat —</option>
            {Array.from({ length: Math.max(cfg.org_max_depth, 1) }, (_, i) => i + 1).map(n => <option key={n} value={n}>Nivelul {n}</option>)}
          </select>
          <div style={{ fontSize: 12, color: "#64748B", marginTop: 4 }}>
            Nivelul 1 este rădăcina structurii (de exemplu facultatea). Fără această setare, vechimea în departament
            nu se poate calcula automat.
          </div>
        </div>
        <div style={{ maxWidth: 420 }}>
          <label className="label">Plafonul reducerii de normă pentru funcții de conducere (%)</label>
          <input className="input" type="number" min="0" max="100" value={cfg.max_management_norm_reduction_percent}
            onChange={e => setCfg({ ...cfg, max_management_norm_reduction_percent: e.target.value })} data-testid="sfd-max-reduction" />
          <div style={{ fontSize: 12, color: "#64748B", marginTop: 4 }}>Valoarea legală inițială este 50%.</div>
        </div>
      </div>
    </>
  );
}
